import React, { useState } from "react";
import PropTypes from "prop-types";

import SidebarTransition from "../../../Shared/Components/MacroSidebar/SidebarTransition";

import SidebarEmojiPicker from "../../../Shared/Components/IconsSidebar/SidebarEmojiPicker";
import SidebarIconPicker from "../../../Shared/Components/IconsSidebar/SidebarIconPicker/SidebarIconPicker";
import SidebarAppPicker from "../../../Shared/Components/IconsSidebar/SidebarAppPicker";

const Tabs = ["Emojis", "Icons", "Logos"];

function IconsSidebar({
  isOpen,
  setIsOpen,
  onIconChange,
  onEmojiChange,
  onAppChange,
  selectedIcon,
  tabs = Tabs,
  containerStyles = {
    top: "56px",
  },
  activeTab = "Icons",
}) {
  const [selectedTab, setSelectedTab] = useState(activeTab);

  return (
    <SidebarTransition
      isOpen={isOpen}
      position="right"
      width={300}
      containerStyles={containerStyles}
      additionalStyle={{
        padding: "0 13px 0 0",
      }}
      showTabs
      tabs={tabs}
      selectedTab={selectedTab}
      close={() => setIsOpen(false)}
      setSelectedTab={setSelectedTab}
    >
      {selectedTab === Tabs[0] && (
        <SidebarEmojiPicker
          handleClickOnEmoji={(value) => onEmojiChange(value)}
        />
      )}
      {selectedTab === Tabs[1] && (
        <div style={{ width: "calc(100% + 13px)" }}>
          <SidebarIconPicker
            icon={selectedIcon}
            onIconSelect={(value) => onIconChange(value)}
          />
        </div>
      )}
      {selectedTab === Tabs[2] && (
        <div style={{ width: "calc(100% + 13px)" }}>
          <SidebarAppPicker
            appIcon={selectedIcon}
            onIconSelect={(value) => onAppChange(value.path)}
          />
        </div>
      )}
    </SidebarTransition>
  );
}

IconsSidebar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func,
  onIconChange: PropTypes.func,
  onEmojiChange: PropTypes.func,
  onAppChange: PropTypes.func,
  selectedIcon: PropTypes.string,
};

IconsSidebar.defaultProps = {
  setIsOpen() {},
  onIconChange() {},
  onEmojiChange() {},
  onAppChange() {},
  selectedIcon: null,
};

export default IconsSidebar;
